import RuejaiClubGroupCategoryListPage from "./pages/RuejaiClubGroupCategoryListPage";
import RuejaiClubGroupCategoryDetailPage from "./pages/RuejaiClubGroupCategoryDetailPage";

export const ruejaiClubGroupCategoryRoutes = (prefix = "group-categories") => [
  {
    name: "RuejaiClubGroupCategoryDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubGroupCategoryDetailPage
  },
  {
    name: "RuejaiClubGroupCategoryListPage",
    path: prefix,
    component: RuejaiClubGroupCategoryListPage
  }
];
